module.exports = __webpack_public_path__ + "assets/img/LTC048.b80802d1.png";